import { wrap } from 'comlink'

const worker = new Worker(new URL('./webworker', import.meta.url), {
  name: 'webworker',
  type: 'module',
})

export default wrap<import('./webworker').WebworkerInterface>(worker)
